<template>
<div>
  <div class="xs-header-wrap">
    <div class="xs-header-inner">
        <div class="inbox">
          <a target="_blank" href="https://51xueshuo.com/#/submission"><h3>{{ $t("common.home") }}</h3></a>
          <el-dropdown placement="bottom-start" @command="handleCommand">
            <h3 class="el-dropdown-link">
              {{ $t("common.meetManager") }}<i class="el-icon-arrow-down el-icon--right"></i>
            </h3>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in openMeetingList" :key="i" :command="item.meetingCode">{{ lang === "zh" ? item.meetingSubject || item.meetingSubjectEn : item.meetingSubjectEn || item.meetingSubject}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="inbox">
          <div @click="goSubmission" v-if="isPc">
            <span style="font-size: 14px;">{{ $t("front.submit") }}</span>
          </div>
          <div class="" v-if="!isLogin && isPc" style="width:100px;">
            <span @click="login">{{ $t("common.signIn") }}</span>
            <i class="shu"></i>
            <span @click="register" style="margin-right: 10px;white-space: nowrap">{{ $t("common.signUp") }}</span>
          </div>
          <div v-if="isLogin" @click="clickUserName">
            <span style="font-size: 14px;">{{userName}}</span>
          </div>
          <span v-if="showChangeLanguage" class="lang-box" @click="changeLang"  style="margin: 0 10px;">
            {{ lang == "zh" ? "EN" : "中文" }}
          </span>
          <el-dropdown v-if="!isPc" >
            <span class="el-dropdown-link">
              <i class="menu el-icon-s-operation" style="margin-right: 10px;"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleClick(2)">{{$t('front.importantDate')}}</el-dropdown-item>
              <el-dropdown-item @click.native="handleClick(3)">{{$t('front.meetIntroduce')}}</el-dropdown-item>
              <el-dropdown-item @click.native="handleClick(4)">{{$t('front.meetSchedule')}}</el-dropdown-item>
              <el-dropdown-item @click.native="handleClick(5)">{{$t('front.meetOther')}}</el-dropdown-item>
              <el-dropdown-item @click.native="goSubmission">{{$t('front.submit')}}</el-dropdown-item>
              <el-dropdown-item @click.native="login">{{$t('common.signIn')}}</el-dropdown-item>
              <el-dropdown-item @click.native="register">{{$t("common.signUp")}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
  </div>
  <!-- <div class="blank-space"></div> -->
</div>
</template>
<script>
import {fa} from "timeago.js/lib/lang";

export default {
  name: "xs-header",
  data() {
    return {
      lang: "",
      isLogin:false,

      meetingSubject:'',
      meetingSubjectEn:'',
      userName:'',

      showChangeLanguage:false,
      openMeetingList: []
    };
  },
  props:['isPc','isOpenParm','previewPage'],
  components: {
  },
  computed: {

  },
  methods: {
    //下拉框
    handleClick(num){
      this.$emit('goLocation',num)
    },
    //   切换语言
    changeLang() {
      if (this.lang == "zh") {
        this.lang = "en";
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
        this.$store.commit('setLang','en');
        this.$router.replace({
          path: this.$route.path,
          query: Object.assign({}, this.$route.query, {
            l: "en",
            _: +new Date(),
          }),
        });
      } else {
        this.lang = "zh";
        this.$i18n.locale = "zh";
        localStorage.setItem("lang", "zh");
        this.$store.commit('setLang','zh');
        this.$router.replace({
          path: this.$route.path,
          query: Object.assign({}, this.$route.query, {
            l: "zh",
            _: +new Date(),
          }),
        });
      }
      this.$emit('typeLanguageFunc',this.lang)
    },
    openDialog() {

    },
    // 注册
    register() {
      if(!this.isPc){
        this.$message.info(this.$t("front.goPc"));
        return false;
      }
      // this.$router.push('/register/' + this.$route.params.meetingCode)
      const curUrl = window.location.href;
      const url = process.env.VUE_APP_LOGIN_HOST + '/#/register?redirect=' + encodeURIComponent(curUrl)
      window.location.href = url
    },
    // 登录
    login() {
      if(!this.isPc){
        this.$message.info(this.$t("front.goPc"));
        return false;
      }
      // this.$router.push('/login/' + this.$route.params.meetingCode)
      const curUrl = window.location.href;
      const url = process.env.VUE_APP_LOGIN_HOST  + '/#/login?redirect=' + encodeURIComponent(curUrl)
      window.location.href = url
    },
    // 退出登录
    exit() {
      this.lang = localStorage.getItem("lang")
        ? localStorage.getItem("lang")
        : "zh";
      // 清空本地存储
      localStorage.clear();
      localStorage.setItem("lang", this.lang);

    },
    // 投稿操作
    goSubmission(){
      if(!this.isPc){
        this.$message.info(this.$t("front.goPc"));
        return false;
      }
      if(!this.isLogin){
        this.login()
      }else{
        this.$router.push({
          path: "/Papers",
        })
        this.$store.commit("selectMenu", {
          label: "论文列表",
          name: "Papers",
          path: "/Papers",
        });
      }
    },
    // 获取会议详情
    getMeetingDetail(){
      let that = this;
      const data = {
        meetingCode: this.$route.params.meetingCode,
        deviceId:localStorage.getItem('Fingerprint2')
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          if(res.data){
            that.meetingSubject = res.data.meetingSubject;
            that.meetingSubjectEn = res.data.meetingSubjectEn
            this.$store.commit("setCurrentMeetingObj", {...res.data,...{label:that.meetingSubject,labelEn:that.meetingSubjectEn}});
            this.$store.commit("setCurrentMeetingCode", res.data.meetingCode);
            
            const title = res.data.meetingShortName?res.data.meetingShortName:'学说会议';
            document.title = title //动态设置title

            if(res.data.languageType == 0){
              that.lang = 'en';
              that.changeLang();
            }else if(res.data.languageType == 1){
              that.lang = 'zh';
              that.changeLang();
            }else{
              that.showChangeLanguage = true;
            }
            that.$emit('typeLanguageFunc',that.lang)
          }
        }
      });
    },
    getUserDetail(){
      this.$api.getCrUserInfo({},'get').then(res=>{
        if(res.code==200){
          this.userName = res.data.name
          localStorage.setItem('userId',res.data.userId)
          this.$store.commit("setCurrentRole", res.data.roleCode);
          this.$store.commit("setCurrentRoleName", res.data.role);
          this.requestAuthorityData(res.data.roleCode);
        }
      })
    },
    /**
     * 权限相关
     * */
    requestAuthorityData(role) {
      let data = {
        roleCode: role,
      };
      this.$api.getMenu(data, "postObj").then((res) => {
        if (res.code == 200) {
          this.authorityObj.setAuthorityData(res.data);
          this.authorityObj.setAuthorityButtonData(res.data);
          this.authorityObj.setAuthorityPageData(res.data);

          this.$store.commit("resetTabsList");

          if (this.authorityObj.isShowPage("#12#13")) {
            this.getMeetingList();
          }
        }
      });
    },

    //存储权限数据
    setAuthorityData() {
      let asideData = [
        {
          path: "/home",
          name: "home",
          label: "首页",
          icon: "s-home",
        },
      ]; //
      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.node.menuCode == "#5") {
          //#5
          let xobj = {};
          xobj.label = "用户管理";
          xobj.icon = "user";
          if (x.childNodes && x.childNodes.length > 0) {
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#5#6") {
                xobj.path = "/user";
                xobj.name = "user";
                xobj.label = y.node.menuName;
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#12") {
          //#5
          let xobj = {};
          xobj.label = "会议管理";
          xobj.label = x.node.menuName;
          xobj.icon = "suitcase";
          if (x.childNodes && x.childNodes.length > 0) {
            xobj.children = [];
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#12#13") {
                let inobj = {
                  path: "/meetManager",
                  name: "meetManager",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#19") {
          //#5
          let xobj = {};
          xobj.label = "论文管理";
          xobj.label = x.node.menuName;
          xobj.icon = "s-promotion";
          if (x.childNodes && x.childNodes.length > 0) {
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#19#20") {
                xobj.children = [];
                let inobj = {
                  path: "/Papers",
                  name: "Papers",
                  label: y.node.menuName,
                  icon: "setting",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#1") {
          //#5
          let xobj = {};
          xobj.label = "个人中心";
          xobj.label = x.node.menuName;
          xobj.icon = "s-custom";
          if (x.childNodes && x.childNodes.length > 0) {
            xobj.children = [];
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#1#3") {
                let inobj = {
                  path: "/personCenterManager",
                  name: "personCenterManager",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
              if (y.node.menuCode == "#1#2") {
                let inobj = {
                  path: "/personCenterInfo",
                  name: "personCenterInfo",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
              if (y.node.menuCode == "#1#4") {
                let inobj = {
                  path: "/personCenterLogs",
                  name: "personCenterLogs",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }
      });

      this.$store.commit("setAsideData", asideData);
    },
    //设置按钮权限  数组保存
    setAuthorityButtonData() {
      let AuthorityButtonArr = [];

      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.childNodes && x.childNodes.length > 0) {
          x.childNodes.some((y) => {
            if (y.childNodes && y.childNodes.length > 0) {
              y.childNodes.some((z) => {
                let obj = {};
                obj.menuCode = z.node.menuCode;
                obj.menuName = z.node.menuName;
                AuthorityButtonArr.push(obj);
              });
            }
          });
        }
      });
      this.$store.commit("setAuthorityButtonArr", AuthorityButtonArr);
    },
    //设置页面权限  数组保存
    setAuthorityPageData() {
      let AuthorityPageArr = [];

      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.childNodes && x.childNodes.length > 0) {
          x.childNodes.some((y) => {
            let obj = {};
            obj.menuCode = y.node.menuCode;
            obj.menuName = y.node.menuName;
            AuthorityPageArr.push(obj);
          });
        }
      });
      this.$store.commit("setAuthorityPageArr", AuthorityPageArr);
    },
    clickUserName(){
      localStorage.setItem('meetingCode',this.$route.params.meetingCode)
      this.$store.commit('setCurrentMeetingCode',this.$route.params.meetingCode);
      this.$router.push({
        name:'home'
      })
    },
    handleCommand(meetingCode){
      this.$router.replace('/index/'+meetingCode);
      window.location.reload();
    }
  },
  created() {
    this.lang = localStorage.getItem("lang") || "zh";
    // 获取token
    this.token = localStorage.getItem("authorization");
    this.isLogin = this.token

    if(this.isLogin){
      this.getUserDetail();
    }

  },
  mounted(){
    if(this.previewPage){
      this.getMeetingDetail();
    }else{
      if(this.isOpenParm){
        this.getMeetingDetail();
      }
    }

    this.$api.getAllOpenMeetingList({}).then((res) => {
      this.openMeetingList = res.data;
    })
  },

};
</script>
<style lang="scss" scoped>
  .xs-header-wrap {
    height: 60px;
    background: $themeColor;
    display: flex;
    justify-content: center;
    .xs-header-inner{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      width:960px;
      .inbox{
        display: flex;
        align-items: center;
        justify-content: center;
        .lang-box{
          width: 36px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 11px;
          border: 1px solid #979797;
        }
        a{
          margin-right: 8px;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        h3{
          font-size: 14px;
          margin-left: 10px;
          color:#fff;
          cursor: pointer;
        }
        span{
          color: #fff;
          font-size: 14px;
          margin: 0 5px;
          cursor: pointer;
        }
        .shu {
          display: inline-block;
          width: 1px;
          height: 22px;
          background-color: #fff;
        }
        .menu{
          display: inline-block;
          width: 18px;
          height: 18px;
          color: #fff;
          font-size: 18px;
        }
      }
      img{
        height: 24px;
        // width:80px;
      }
    }
  }
  @media screen and (max-width: 900px) {
    .right-box{
      position: absolute;
      right: 0px;
    }
  }

</style>
